import Dexie, { type EntityTable } from "dexie";

// if the data was cleaned, then maybe it might be Box->Artwork

export interface Box {
  id: string;
  source: "user" | "import"; // whether it's been added by a user

  lat: number;
  lon: number;

  title: string;
  location: string;
  artist: string;
  url: string;
  year: string;

  // from scraped data
  council: string;
  description: string;
  biography: string;
  links: string;
}

export interface BoxImage {
  id: number;
  artist: string;
  src: string;
  thumb: string;
}

export interface Checkin {
  id: number;
  time: number;

  boxId: string;

  // of the checkin (not the box)
  lat: number;
  lon: number;

  note: string;
}

export interface Media {
  id: number;
  checkinId: number;
  file: Blob;
}

export const db = new Dexie("CanvasTrail") as Dexie & {
  boxes: EntityTable<Box, "id">;
  boxImages: EntityTable<BoxImage, "id">;
  checkins: EntityTable<Checkin, "id">;
  media: EntityTable<Media, "id">;
};

db.version(2).stores({
  boxes: "id, source, [lon+lat]",
  boxImages: "id, artist",
  checkins: "++id, time, boxId",
  media: "++id, checkinId",
});
